import type { UseDataFetcherOptions } from '~/components/useDataFetcher';
import useDataFetcher from '~/components/useDataFetcher';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';

import { useCms } from './useCms';

/**
 * Fetch a single contact by ID using the org-scoped endpoint.
 *
 * Resolves the organization ID from CMS context so callers don't need to
 * know about the `/organizations/<orgId>/contacts/<contactId>` URL shape.
 */
function useFetchContact(contactId: number | string | null | undefined, options?: UseDataFetcherOptions) {
  const { userOrganization } = useCms();
  const url =
    contactId && userOrganization?.id ? `/api/v1/organizations/${userOrganization.id}/contacts/${contactId}` : null;

  return useDataFetcher<ContactFullModel>(url, null, options);
}

export default useFetchContact;
